import { Flex, StyleProps, Text } from '@chakra-ui/react';
import { UserAvatar } from '../User/UserAvatar';
import { useBuyerOfferAnalysisContext } from './Context/BuyerOfferAnalysisContext';

export const PreparedBy = ({ ...styleProps }: StyleProps) => {
  const { buyerOfferAnalysis } = useBuyerOfferAnalysisContext();
  const buyersAgent = buyerOfferAnalysis?.buyersAgent?.user;

  if (!buyersAgent) return null;

  return (
    <Flex alignItems="center" gap={3} height="100%" px={4} {...styleProps}>
      <Text
        color="white"
        fontSize="md"
        fontWeight="medium"
        noOfLines={1}
        whiteSpace="nowrap"
      >
        Prepared by
      </Text>
      <Flex alignItems="center" gap={2}>
        <UserAvatar
          size="sm"
          user={{
            fullName: buyersAgent.fullName,
            profilePicture: buyersAgent.profilePicture,
          }}
        />
        <Text
          color="white"
          fontSize="md"
          fontWeight="medium"
          noOfLines={1}
          whiteSpace="nowrap"
        >
          {buyersAgent.fullName}
        </Text>
      </Flex>
    </Flex>
  );
};
